import React, { FC } from 'react';
import type { DlpPageStatsProps } from 'src/search/components/DlpPageStats';
import DlpLayout from 'src/search/components/DlpLayout';
import type { DlpListingsProps } from 'src/search/components/DlpListings';
import DlpListings from 'src/search/components/DlpListings';

export type DlpListingsRecommendedProps = {
  /** On desktop, DlpPageStats is shown as a subtitle of this section */
  pageStats?: DlpPageStatsProps;
} & DlpListingsProps;

/**
 * A simple wrapper around DlpListings to keep DlpLayout out of DlpRoot
 * Following the pattern of other components.
 * It does have a unique prop of `pageStats`, which is only used in "Our Favorites" type of Listings
 */
const DlpListingsRecommended: FC<DlpListingsRecommendedProps> = ({
  listings,
  title,
  categorySlug,
  pageStats,
  locationSlug,
  ...dataAttributes
}) => (
  <DlpLayout>
    <DlpListings
      title={title}
      listings={listings}
      categorySlug={categorySlug}
      locationSlug={locationSlug}
      pageStats={pageStats}
      firstContentfulPaint // this component is always shown near the first contentful paint
      {...dataAttributes}
    />
  </DlpLayout>
);

export default DlpListingsRecommended;
